import * as React from "react";
import { IconProps } from "../types";

const SuitcaseOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M9 9.5C9.41421 9.5 9.75 9.16421 9.75 8.75C9.75 8.33579 9.41421 8 9 8C8.58579 8 8.25 8.33579 8.25 8.75C8.25 9.16421 8.58579 9.5 9 9.5Z"
          fill={color}
        />
        <path
          d="M15.75 11.5V13.25C15.75 14.355 14.855 15.25 13.75 15.25H4.25C3.145 15.25 2.25 14.355 2.25 13.25V11.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 4.75V2.25C6.25 1.698 6.698 1.25 7.25 1.25H10.75C11.302 1.25 11.75 1.698 11.75 2.25V4.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.902 9.215L9 11.25L3.098 9.215C2.291 8.937 1.75 8.178 1.75 7.324V4.75H16.25V7.324C16.25 8.177 15.709 8.937 14.902 9.215Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default SuitcaseOutlineIcon;
